
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
import TransitionLink from "../components/TransitionLink";
export const title = "Changelog 1: New Year, New Look";
export const description = "A look at all the new features introduced in version 9 of bomberfish.ca.";
export const image = "/blog-images/site-v9.jpg";
export const tags = ["Meta", "Changelog", "Devlog", "Update"];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/site-v9.jpg",
        alt: "A screenshot of this website."
      })
    }), "\n", _jsx(_components.p, {
      children: "It's 2026, and it's time I redesigned this website for the 4th time since last fall. Let's take a look at what's new."
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "I've decided to start doing update logs on the website now. Stay tuned for future updates!"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "New layout"
    }), "\n", _jsx(_components.p, {
      children: "In 9.0, I opted for a much cleaner and more compact layout, with a centered content box. On mobile, the box occupies the entire screen for visual neatness. It also adapts well to smaller displays and older browsers."
    }), "\n", _jsx(_components.h2, {
      children: "Refined visual language"
    }), "\n", _jsx(_components.p, {
      children: "Since 9.0 is mainly a layout overhaul, the general visual language of 8.x has been mostly left intact, with tweaks to how elevated surface colors are used. More iconography is present throughout the site, and the appearance of things like borders has been consolidated."
    }), "\n", _jsx(_components.h2, {
      children: "Adjusted colour palette"
    }), "\n", _jsxs(_components.p, {
      children: ["The palette from 8.x has been tweaked a considerable amount, being somewhat darkened and with the hue shifted to match that of ", _jsx("a", {
        href: "/me.png",
        target: "_blank",
        children: "my new profile picture"
      }), ". Additionally, I've refractored how certain colors are computed, adding more flexibility to the palette. You can even temporarily hue-rotate the palette using the slider in the \"", _jsx(TransitionLink, {
        href: "/siteinfo",
        class: "router-link",
        children: "About This Website"
      }), "\" page. Note that it does not persist on a full reload."]
    }), "\n", _jsx(_components.h2, {
      children: "Updated background"
    }), "\n", _jsx(_components.p, {
      children: "Gone is the slow-to-load dithered background from 7.x and 8.x. In 9.1 (which was released the day after 9.0), it's been replaced with the grid from late 6.x, which in it of itself it a modified version of the dot grid of 5.x. A couple of the parameters were tweaked to match the vibe of version 9, but it remains largely unchanged from its 6.2 incarnation."
    }), "\n", _jsx(_components.h2, {
      children: "Overhauled projects page"
    }), "\n", _jsxs(_components.p, {
      children: ["Keeping with the theme of bringing back older design decisions, the projects page's grid layout from 6.x and 7.x has been brought back in 9.2 (released 2 days after 9.0). Additionally, support has been added for the ", _jsx(_components.a, {
        href: "https://webkit.org/blog/17660/introducing-css-grid-lanes/",
        children: "finalized version of CSS masonry"
      }), ", meaning an even more beautiful layout will be coming soon to a modern browser near you!"]
    }), "\n", _jsx(_components.h2, {
      children: "Performance and compatibility"
    }), "\n", _jsxs(_components.p, {
      children: ["I've been hard at work improving performance. That's why I'm glad to announce that bomberfish.ca has achieved a perfect score across all categories in Lighthouse desktop performance! Font loading was optimized to lazily load web fonts, with the page using the system's installed version of the regular Helvetica font and swapping Helvetica Now in when it loads. I've also removed various unused assets, and while the CSS bundle size has risen since last time, I was able to increase browser compatibility. I can now confirm that the site ", _jsx(_components.a, {
        href: "https://wetdry.world/@fish/115858737045320286",
        children: "functions with a near-perfect layout"
      }), " on Firefox 10!"]
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	